export default __webpack_public_path__ + "static/media/vod.dc5b4a7d.svg";